import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Change Impact Summary',
      type: 'report-card',
      content: {
        '[]': [
          {
            '{}': {
              name: 'Change Impacts',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Total Impacts',
                      value: {
                        '{}': {
                          aside: '',
                          emphasis: {
                            '#': {
                              '@': 'totalImpacts',
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Validated Impacts',
                      value: {
                        '{}': {
                          aside: 'Validation = Completed',
                          emphasis: {
                            '#': {
                              '@': 'validatedImpacts',
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Open Impacts',
                      value: {
                        '{}': {
                          aside: 'Status ≠ Completed',
                          emphasis: {
                            '#': {
                              '@': 'openImpacts',
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'High-Degree Impacts',
                      value: {
                        '{}': {
                          aside: 'Degree of Change = High',
                          emphasis: {
                            '#': {
                              '@': 'highDegreeImpacts',
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Workstreams with Active Items',
                      value: {
                        '{}': {
                          aside: 'Status ≠ Completed',
                          emphasis: {
                            '#': {
                              uniq: {
                                '@': 'activeWorkstreamValues',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      },
    },
  },
  subqueries: {
    openImpacts: {
      filter: {
        '!=': [
          {
            '@.': '!status',
          },
          'Completed',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highDegreeImpacts: {
      filter: {
        '=': [
          {
            '@.': '!degree_of_change',
          },
          'High',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    activeWorkstreamValues: {
      filter: {
        '!=': [
          {
            '@.': '!status',
          },
          'Completed',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!workstream',
      },
    },
    totalImpacts: {
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    overdueImpacts: {
      filter: {
        and: [
          {
            '!=': [
              {
                '@.': '!status',
              },
              'Completed',
            ],
          },
          {
            '<': [
              {
                '@.': '!target_go_live_date',
              },
              {
                $date: 'today',
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    workdayImpacts: {
      filter: {
        '=': [
          {
            '@.': '!system',
          },
          'Workday',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    completedImpacts: {
      filter: {
        '=': [
          {
            '@.': '!status',
          },
          'Complete',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    validatedImpacts: {
      filter: {
        '=': [
          {
            '@.': '!validation_status',
          },
          'Completed',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highPriorityImpacts: {
      filter: {
        '=': [
          {
            '@.': '!priority',
          },
          'High',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    kindsightAscendImpacts: {
      filter: {
        '=': [
          {
            '@.': '!system',
          },
          'Kindsight Ascend',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
